import IconDownload from '@src/assets/images/common/icon/chat-action/icon-download.svg';
import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import Tooltip from '@src/features/shared/community/components/chat/Tooltip';

import SpBottomMenuLayout from './SpBottomMenuLayout';

const AttachmentActionMenuSp = ({
  handleCloseClick,
  handleDownloadClick,
  showTooltip = false,
  fileUrl,
  fileName,
}: {
  handleCloseClick: () => void;
  handleDownloadClick: () => void;
  showTooltip?: boolean;
  fileUrl?: string;
  fileName?: string;
}) => {
  // @ts-expect-error define global variables for iOS detection
  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const { profile } = useSharedAuth();
  const isLoggedIn = profile?.companyProfile?.isLogin ?? profile?.tenantProfile?.isLogin;

  return (
    <>
      <SpBottomMenuLayout
        handleCloseClick={handleCloseClick}
        initPositionY='120px'
      >
        <div className='px-[25px] pb-8 pt-[34px]'>
          <ul className='mx-auto max-w-[340px]'>
            <li className='h-[50px]'>
              <div className='flex items-center gap-2'>
                <img
                  src={IconDownload}
                  alt=''
                />
                {isIos && fileUrl ? (
                  <a
                    href={isLoggedIn ? fileUrl : undefined}
                    download={fileName}
                    className='size-full text-left'
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isLoggedIn) {
                        return;
                      }
                      // 画像プレビューモーダルと同じく、setIsFileDownloadingを使用しない
                      // これによりチャットのポーリングに影響せず、500エラーを回避
                    }}
                  >
                    ファイルをダウンロードする
                  </a>
                ) : (
                  <button
                    className='size-full text-left'
                    onClick={handleDownloadClick}
                  >
                    ファイルをダウンロードする
                  </button>
                )}
              </div>
              {showTooltip && (
                <div className='lg:ml-[2px] lg:text-[12px]'>
                  <Tooltip
                    label='ダウンロードするには、ログインしてください。'
                    weight='500'
                  />
                </div>
              )}
            </li>
          </ul>
        </div>
      </SpBottomMenuLayout>
    </>
  );
};

export default AttachmentActionMenuSp;
